import React from 'react';
import { AppBar, Toolbar, Typography, Container, Box, IconButton, Tooltip } from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import Sidebar from './Sidebar';
import { useTheme } from '../contexts/ThemeContext';

const Header = () => {
  const { themeMode, toggleTheme } = useTheme();
  
  return (
    <AppBar 
      position="static" 
      sx={{ 
        borderRadius: 0, 
        background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 50%, #0d47a1 100%)',
        boxShadow: '0 4px 20px rgba(25, 118, 210, 0.3)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          boxShadow: '0 6px 25px rgba(25, 118, 210, 0.4)',
          transform: 'translateY(-1px)',
        },
      }}
    >
      <Container maxWidth="xl">
        <Toolbar 
          disableGutters 
          sx={{ 
            borderRadius: 0,
            minHeight: '64px',
            transition: 'all 0.3s ease',
          }}
        >
          <Sidebar />
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ 
              mr: 2, 
              display: { xs: 'none', md: 'flex' },
              fontWeight: 'bold',
              background: 'linear-gradient(45deg, #ffffff 30%, #e3f2fd 90%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              textShadow: '0 2px 4px rgba(0,0,0,0.3)',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'scale(1.05)',
                textShadow: '0 4px 8px rgba(0,0,0,0.4)',
              }
            }}
          >
            股票信号网
          </Typography>
          <Typography
            variant="subtitle1"
            noWrap
            component="div"
            sx={{ 
              flexGrow: 1, 
              display: { xs: 'none', md: 'flex' },
              color: 'rgba(255, 255, 255, 0.8)',
              fontStyle: 'italic',
              transition: 'all 0.3s ease',
              '&:hover': {
                color: 'rgba(255, 255, 255, 1)',
                transform: 'translateX(5px)',
              }
            }}
          >
            stockSignals.cn
          </Typography>
          
          {/* 主题切换按钮 */}
          <Tooltip title={themeMode === 'light' ? '切换到深色模式' : '切换到浅色模式'}>
            <IconButton 
              onClick={toggleTheme} 
              color="inherit" 
              sx={{ 
                ml: 1,
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(10px)',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                  background: 'rgba(255, 255, 255, 0.2)',
                  transform: 'rotate(180deg) scale(1.1)',
                  boxShadow: '0 4px 15px rgba(255, 255, 255, 0.3)',
                },
                '&:active': {
                  transform: 'rotate(180deg) scale(0.95)',
                }
              }}
            >
              {themeMode === 'light' ? <Brightness4Icon /> : <Brightness7Icon />}
            </IconButton>
          </Tooltip>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;